import { css } from '@emotion/react';

const createGlobalStyles = (theme) =>
  css`
    /**
    * Modified ress.css • v2.0.4
    * MIT License
    * github.com/filipelinhares/ress
    */

    :root {
      font-size: 16px;
    }

    body {
      height: 100%;
      background-color: ${theme.colors.globals.body.bg};
      box-sizing: border-box;
      color: ${theme.colors.globals.body.foreground};
      font-family: ${theme.typography.fontFamily};
      font-weight: ${theme.typography.fontWeights.regular};
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      margin: 0;
      -moz-tab-size: 4;
      tab-size: 4;
      -webkit-text-size-adjust: 100%;
      text-rendering: optimizeLegibility;
      word-break: normal;
    }

    *,
    ::before,
    ::after {
      background-repeat: no-repeat;
      box-sizing: inherit;
    }

    ::before,
    ::after {
      text-decoration: inherit;
      vertical-align: inherit;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-size: 1rem;
      font-weight: 400;
      margin: 0;
    }

    * {
      padding: 0;
      margin: 0;
    }

    hr {
      overflow: visible;
      height: 0;
    }

    details,
    main {
      display: block;
    }

    summary {
      display: list-item;
    }

    small {
      font-size: 80%;
    }

    [hidden] {
      display: none;
    }

    abbr[title] {
      border-bottom: none;
      text-decoration: underline;
      text-decoration: underline dotted;
    }

    a {
      color: ${theme.colors.globals.anchor.foreground};
      background-color: transparent;
    }

    a:hover {
      ${theme.colors.globals.anchor.foregroundHover};
    }

    a:active {
      ${theme.colors.globals.anchor.foregroundActive};
    }

    a:active,
    a:hover {
      outline-width: 0;
    }

    code,
    kbd,
    pre,
    samp {
      font-family: monospace, monospace;
    }

    b,
    strong {
      font-weight: bolder;
    }

    input {
      border-radius: 0;
    }

    [disabled] {
      cursor: default;
    }

    [type='number']::-webkit-inner-spin-button,
    [type='number']::-webkit-outer-spin-button {
      height: auto;
    }

    [type='search'] {
      -webkit-appearance: textfield;
      outline-offset: -2px;
    }

    [type='search']::-webkit-search-decoration {
      -webkit-appearance: none;
    }

    textarea {
      overflow: auto;
      resize: vertical;
    }

    optgroup {
      font-weight: bold;
    }

    button {
      overflow: visible;
    }

    button,
    select {
      text-transform: none;
    }

    button,
    [type='button'],
    [type='reset'],
    [type='submit'],
    [role='button'] {
      cursor: pointer;
      color: inherit;
    }

    button::-moz-focus-inner,
    [type='button']::-moz-focus-inner,
    [type='reset']::-moz-focus-inner,
    [type='submit']::-moz-focus-inner {
      border-style: none;
      padding: 0;
    }

    button:-moz-focusring,
    [type='button']::-moz-focus-inner,
    [type='reset']::-moz-focus-inner,
    [type='submit']::-moz-focus-inner {
      outline: 1px dotted ButtonText;
    }

    button,
    html [type='button'],
    Android 4 [type='reset'],
    [type='submit'] {
      -webkit-appearance: button;
    }

    button,
    input,
    select,
    textarea {
      background-color: transparent;
      border-style: none;
    }

    select {
      -moz-appearance: none;
      -webkit-appearance: none;
    }

    select::-ms-expand {
      display: none;
    }

    select::-ms-value {
      color: currentColor;
    }

    legend {
      border: 0;
      color: inherit;
      display: table;
      max-width: 100%;
      white-space: normal;
      max-width: 100%;
    }

    ::-webkit-file-upload-button {
      -webkit-appearance: button;
      color: inherit;
      font: inherit;
    }

    progress {
      vertical-align: baseline;
    }

    svg:not([fill]) {
      fill: currentColor;
    }

    @media screen {
      [hidden~='screen'] {
        display: inherit;
      }

      [hidden~='screen']:not(:active):not(:focus):not(:target) {
        position: absolute !important;
        clip: rect(0 0 0 0) !important;
      }
    }

    [aria-busy='true'] {
      cursor: progress;
    }

    [aria-controls] {
      cursor: pointer;
    }

    [aria-disabled] {
      cursor: default;
    }

    .modal__body--open {
      height: 100%;
      overflow-y: hidden;
      -webkit-overflow-scrolling: auto;
    }
  `;

export default createGlobalStyles;
